import { all } from 'redux-saga/effects';
import ApplicantSaga from './ApplicantSaga';
import QualificationsSaga from './QualificationsSaga';
import CategoriesSaga from './CategoriesSaga';
import SignatureSaga from './SignatureSaga';

export default function* () {
  yield all([
    ApplicantSaga(),
    QualificationsSaga(),
    CategoriesSaga(),
    SignatureSaga(),
  ]);
}
